// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/overview/sales_history/$saleId/-components/component";
import { SalesHistorySearchParams } from "@/routes/(pharma)/_layout/overview/-data/schema";
import { SaleOne } from "@/routes/(pharma)/_layout/receipt/-data/model";
import { httpClient } from "@/httpClient";
import { Loading } from "@/layouts/loading";
import { GetSaleResponse } from "@/gen/sales/get_sale_pb";
import { pharmacyClient } from "@/connect";

const API_URL = import.meta.env.VITE_API_URL as string;

export const Route = createFileRoute("/(pharma)/_layout/overview/sales_history/$saleId/")({
  component: Component,
    validateSearch: SalesHistorySearchParams,
    loader: async ({params}): Promise<GetSaleResponse> => {
        if (!params.saleId) {
            throw new Error("Sale ID is required");
        }
        return await pharmacyClient.getSale({
            saleId: params.saleId
        })
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});
